module.exports = __webpack_public_path__ + "img/coinmall-earndalog.2083e5dc.png";